// alarms_notification

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdAccountCircle, MdClose, MdCheckCircle, MdHighlightOff } from "react-icons/md";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import "./alarm_notification.css";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Alarms = () => {
  const navigate = useNavigate();
  const [alarms, setAlarms] = useState([]);
  const [page, setPage] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedAlarm, setSelectedAlarm] = useState(null);
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [filterType, setFilterType] = useState("ACTIVE");
  const [loading, setLoading] = useState(false);


  const API_URL = process.env.REACT_APP_API_DJANGO_URL;
  const role = localStorage.getItem("role");


  // Helper to get Status Badge styling and text (Identical to AlarmsPage)
  const getStatusLabel = (status) => {
    const labels = {
      ACTIVE_UNACK: { text: "Active / Unack", class: "status-active-unack" },
      ACTIVE_ACK: { text: "Active / Ack", class: "status-active-ack" },
      CLEARED_UNACK: { text: "Cleared / Unack", class: "status-cleared-unack" },
      CLEARED_ACK: { text: "Resolved", class: "status-resolved" },
    };
    return labels[status] || { text: status.replace("_", " "), class: "" };
  };

  useEffect(() => {
    let interval;
    if (selectedAlarm) {
      interval = setInterval(() => setCurrentTime(Date.now()), 1000);
    }
    return () => clearInterval(interval);
  }, [selectedAlarm]);



  useEffect(() => {
    fetchAlarms(page, rowsPerPage, filterType);
  }, [page, rowsPerPage, filterType]);





  // const fetchAlarms = async (pageNumber = 0, size = rowsPerPage) => {
  //   const token = localStorage.getItem("accessToken");
  //   try {
  //     const res = await fetch(
  //       `${API_URL}/api/get_alarms_notification/`,
  //       { headers: {    "Authorization": `Bearer ${token}`,
  //   "Accept": "application/json",
  //   "Content-Type": "application/json" 
  //     } }
  //     );
  //     const data = await res.json();
  //     setAlarms(data.data || []);
  //     setTotalElements(data.totalElements || 0);
  //     setPage(pageNumber);
  //   } catch (err) {
  //     console.error("Failed to fetch alarms", err);
  //   }
  // };



  // const filteredAlarms = alarms.filter((alarm) => {
  //   if (filterType === "ACTIVE") {
  //     return alarm.status.startsWith("ACTIVE");
  //   }

  //   if (filterType === "CLEARED") {
  //     return alarm.status.startsWith("CLEARED");
  //   }

  //   return true;
  // });

  const fetchAlarms = async (
    pageNumber = 0,
    size = rowsPerPage,
    status = filterType
  ) => {

    const token = localStorage.getItem("accessToken");

    try {

      setLoading(true);

      let statusList = "";

      switch (status) {

        case "ACTIVE":
          statusList = "ACTIVE";
          break;

        case "CLEARED":
          statusList = "CLEARED";
          break;

        case "ACK":
          statusList = "ACK";
          break;

        case "UNACK":
          statusList = "UNACK";
          break;

        default:
          statusList = "ACTIVE,CLEARED,ACK,UNACK";
      }

      const res = await fetch(
        `${API_URL}/api/get_filtered_alarms/?pageSize=${size}&page=${pageNumber}&sortProperty=createdTime&sortOrder=DESC&statusList=${statusList}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();

      setAlarms(data.data || []);
      setTotalElements(data.totalElements || 0);
      setPage(pageNumber);

    } catch (err) {

      console.error("Failed to fetch alarms", err);

    } finally {

      setLoading(false);

    }
  };




  const paginatedAlarms = alarms;
  const totalFiltered = totalElements;

  const start = totalFiltered === 0 ? 0 : page * rowsPerPage + 1;

  const end = Math.min(
    page * rowsPerPage + rowsPerPage,
    totalFiltered
  );

  const handleAcknowledge = async (alarmId) => {
    const token = localStorage.getItem("accessToken");
    await fetch(`${API_URL}/api/acknowledge_alarm/${alarmId}/`, {
      method: 'POST',
      headers: {
        "Authorization": `Bearer ${token}`,
        "Accept": "application/json",
        "Content-Type": "application/json"
      }
    });
    fetchAlarms(page, rowsPerPage);
    setSelectedAlarm(null);
  };

  const handleClear = async (alarmId) => {
    const token = localStorage.getItem("accessToken");
    await fetch(`${API_URL}/api/clear_alarm/${alarmId}/`, {
      method: 'POST',
      headers: {
        "Authorization": `Bearer ${token}`,
        "Accept": "application/json",
        "Content-Type": "application/json" // Use "Content-Type" with a hyphen
      }
    });
    fetchAlarms(page, rowsPerPage);
    setSelectedAlarm(null);
  };

  const formatTime = (ts) => (ts ? new Date(ts).toLocaleString() : "---");

  const calculateDuration = (startTs) => {
    const diff = Date.now() - startTs;
    if (diff < 0) return "0s";
    const seconds = Math.floor((diff / 1000) % 60);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const hours = Math.floor(diff / (1000 * 60 * 60));
    return `${hours}h ${minutes}m ${seconds}s`;
  };

  // const start = page * rowsPerPage + 1;
  // const end = Math.min(start + rowsPerPage - 1, totalElements);

  return (
    <div className="alarm-wrapper">
      <div className="alarms-header-main">
        <div className="title-block">
          <button className="back-btn-square" onClick={() => navigate(-1)}>
            <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
          </button>
          <div className="header-text-group">
            <h1>Active Alarms</h1>
            <div className="sub-header">
              <div className="status-dot active" style={{ backgroundColor: '#ef4444', boxShadow: '0 0 5px #ef4444' }}></div>
              <span>REAL-TIME SYSTEM ALERTS</span>
            </div>
          </div>
        </div>
      </div>
      <div className="alarm-filter-bar">
        <select
          value={filterType}
          onChange={(e) => {
            const value = e.target.value;
            setFilterType(value);
            setPage(0);
          }}
          className="alarm-filter-select"
        >
          <option value="ACTIVE">Active</option>
          <option value="CLEARED">Cleared</option>
          <option value="ACK">Acknowledged</option>
          <option value="UNACK">Unacknowledged</option>
          <option value="ALL">All</option>
        </select>
      </div>

      <div className="alarm-card">
        <div className="table-responsive">
          <table className="alarm-table">
            <thead>
              <tr>
                <th>START TIME</th>
                <th>CLEAR TIME</th>
                <th>ORIGINATOR</th>
                <th>ALARM NAME</th>
                <th>STATUS</th>
                <th>SEVERITY</th>
                {/* <th style={{ textAlign: 'center' }}>ACTIONS</th> */}
                {role !== "SE" && (
                  <th style={{ textAlign: 'center' }}>ACTIONS</th>
                )}
              </tr>
            </thead>
            <tbody>

              {loading ? (

                <tr>
                  <td colSpan="7" style={{ textAlign: "center", padding: "40px" }}>
                    <div className="alarm-loader">
                      <div className="spinner"></div>
                      <p>Loading alarms...</p>
                    </div>
                  </td>
                </tr>

              ) : paginatedAlarms.length === 0 ? (

                <tr>
                  <td colSpan="7" style={{ textAlign: "center", padding: "30px" }}>
                    No alarms found
                  </td>
                </tr>

              ) : (

                paginatedAlarms.map((alarm) => {

                  const statusInfo = getStatusLabel(alarm.status);

                  return (
                    <tr key={alarm.id.id}>
                      <td>{formatTime(alarm.startTs)}</td>
                      <td>{alarm.clearTs ? formatTime(alarm.clearTs) : "Active"}</td>
                      <td className="originator-text">{alarm.originatorName}</td>

                      <td className="alarm-name-cell">
                        <button
                          className="alarm-link-btn"
                          onClick={() => setSelectedAlarm(alarm)}
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: 0,
                            textAlign: 'left',
                            fontWeight: 'bold',
                            color: 'inherit'
                          }}
                        >
                          {alarm.name || alarm.type}
                        </button>
                      </td>

                      <td>
                        <span className={`status-badge ${statusInfo.class}`}>
                          {statusInfo.text}
                        </span>
                      </td>

                      <td>
                        <span className={`sev-badge sev-${alarm.severity.toLowerCase()}`}>
                          {alarm.severity}
                        </span>
                      </td>

                      {/* <td>
                        <div
                          className="action-row-icons"
                          style={{
                            display: 'flex',
                            gap: '12px',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                        >

                          {(alarm.status.includes("UNACK")) && (
                            <button
                              className="action-icon-btn ack"
                              onClick={() => handleAcknowledge(alarm.id.id)}
                              title="Acknowledge Alarm"
                              style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#10b981',
                                padding: 0,
                                display: 'flex'
                              }}
                            >
                              <MdCheckCircle size={22} />
                            </button>
                          )}

                          {(!alarm.status.includes("CLEARED")) && (
                            <button
                              className="action-icon-btn clr"
                              onClick={() => handleClear(alarm.id.id)}
                              title="Clear Alarm"
                              style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#ef4444',
                                padding: 0,
                                display: 'flex'
                              }}
                            >
                              <MdHighlightOff size={22} />
                            </button>
                          )}

                          {(alarm.status === "CLEARED_ACK") && (
                            <span
                              style={{
                                fontSize: '11px',
                                color: '#888',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                              }}
                            >
                              RESOLVED
                            </span>
                          )}

                        </div>
                      </td> */}

                      {role !== "SE" && (
                        <td>
                          <div
                            className="action-row-icons"
                            style={{
                              display: 'flex',
                              gap: '12px',
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}
                          >
                            {(alarm.status.includes("UNACK")) && (
                              <button
                                className="action-icon-btn ack"
                                onClick={() => handleAcknowledge(alarm.id.id)}
                                title="Acknowledge Alarm"
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  cursor: 'pointer',
                                  color: '#10b981',
                                  padding: 0,
                                  display: 'flex'
                                }}
                              >
                                <MdCheckCircle size={22} />
                              </button>
                            )}

                            {(!alarm.status.includes("CLEARED")) && (
                              <button
                                className="action-icon-btn clr"
                                onClick={() => handleClear(alarm.id.id)}
                                title="Clear Alarm"
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  cursor: 'pointer',
                                  color: '#ef4444',
                                  padding: 0,
                                  display: 'flex'
                                }}
                              >
                                <MdHighlightOff size={22} />
                              </button>
                            )}

                            {(alarm.status === "CLEARED_ACK") && (
                              <span style={{
                                fontSize: '11px',
                                color: '#888',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                              }}>
                                RESOLVED
                              </span>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })

              )}

            </tbody>
          </table>
        </div>

        <div className="pagination-bar">
          <div className="rows-select">
            Rows per page:
            <select value={rowsPerPage} onChange={(e) => setRowsPerPage(Number(e.target.value))}>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
            </select>
          </div>
          <div className="page-info">
            {start}-{end} of {totalFiltered}
          </div>
          <div className="page-arrows">
            <button
              disabled={page === 0}
              onClick={() => setPage(page - 1)}
            >
              ‹
            </button>
            <button
              disabled={end >= totalFiltered}
              onClick={() => setPage(page + 1)}
            >
              ›
            </button>
          </div>
        </div>
      </div>

      {/* Detail Modal */}
      {selectedAlarm && (
        <div className="modal-overlay">
          <div className="details-modal">
            <div className="modal-header">
              <h3>Alarm Details</h3>
              <button className="close-icon" onClick={() => setSelectedAlarm(null)}>
                <MdClose />
              </button>
            </div>
            <div className="modal-body">
              <div className="detail-grid">
                <div className="detail-item"><label>Name</label><p>{selectedAlarm.name || selectedAlarm.type}</p></div>
                <div className="detail-item"><label>Originator</label><p>{selectedAlarm.originatorName}</p></div>
                <div className="detail-item"><label>Severity</label><p className="bold">{selectedAlarm.severity}</p></div>
                <div className="detail-item"><label>Status</label>
                  <p>
                    <span className={`status-badge ${getStatusLabel(selectedAlarm.status).class}`}>
                      {getStatusLabel(selectedAlarm.status).text}
                    </span>
                  </p>
                </div>
                <div className="detail-item"><label>Duration</label><p>{calculateDuration(selectedAlarm.startTs)}</p></div>
              </div>
              <div className="assignee-section">
                <div className="assignee-box">
                  <MdAccountCircle className="large-avatar" />
                  <div className="assignee-text">
                    <label>Assignee</label>
                    <p>{selectedAlarm.assignee ? `${selectedAlarm.assignee.firstName} ${selectedAlarm.assignee.lastName}` : "Unassigned"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Alarms;